import { gql } from '@apollo/client'

export const UPDATE_APP_SETTING = gql`
  mutation UpdateAppSetting($key: String!, $value: String!) {
    updateAppSetting(input: { key: $key, value: $value }) {
      key
      displayName
      description
      value
      valueType
      lastModifiedBy
      lastModifiedAt
    }
  }
`
